// import Vue from 'vue'
// import Router from 'vue-router'
import { createWebHistory, createRouter } from 'vue-router';
import pathToRegexp from 'path-to-regexp';

//Pinia stores
import { useAuthStore } from '@/stores/auth';

import RBACHelper from '@/RBACHelper';

// These are functions, not direct imports, so the view files only load when that
// route is actually visited, instead of loading every view as soon as anything
// imports this router file.
const Forbidden403 = () => import('@/views/403Forbidden.vue');
const NotFound404 = () => import('@/views/404NotFound.vue');

const AppLayout = () => import('@/views/MainLayout.vue');
const Login = () => import('@/views/Login.vue');
const LandingPage = () => import('@/views/LandingPage.vue');
// import LegacyImportLayout from '@/views/LegacyImportLayout.vue';
import { getUserDetails, getSubscriptionDetails } from '@/services/UserService';

import { MAIN_ROUTE } from '@/routeConstants';

const ShowOperatorLayout = () => import('./views/ShowOperatorLayout.vue');

const COBRAAgentDownload = () => import('@/views/COBRAAgentDownload.vue');

let routes = [
	{
		path: '/',
		optional_subdomains: ['operator'],
		name: 'home',
		component: LandingPage,
		protected: false,
	},

	{
		path: '/landing',
		optional_subdomains: ['operator'],
		name: 'landing',
		component: LandingPage,
		protected: false,
	},

	{
		path: '/app',
		name: 'app',
		component: AppLayout,
		protected: true,
	},
	{
		path: '/shows/:show_id',
		name: 'show',
		component: AppLayout,
		protected: true,
	},
	// {
	// 	path: '/import_show',
	// 	name: 'import_show',
	// 	component: LegacyImportLayout,
	// 	protected: true,
	// },
	{
		path: '/login',
		name: 'login',
		component: Login,
		title: 'Log In',
		is_utility_route: true,
	},

	//Show Operator
	{
		path: '/app',
		subdomains: ['operator'],
		name: 'operator_app',
		component: ShowOperatorLayout,
		protected: true,
	},
	{
		path: '/operator/controls/:default_view_id',
		optional_subdomains: ['operator'],
		name: 'operator_controls_all',
		component: ShowOperatorLayout,
		protected: true,
	},
	{
		path: '/operator/controls/view/:view_id',
		optional_subdomains: ['operator'],
		name: 'operator_controls_view',
		component: ShowOperatorLayout,
		protected: true,
	},
	{
		path: '/operator/overview/:default_view_id',
		optional_subdomains: ['operator'],
		name: 'operator_overview_all',
		component: ShowOperatorLayout,
		protected: true,
	},
	{
		path: '/operator/overview/view/:view_id',
		optional_subdomains: ['operator'],
		name: 'operator_overview_view',
		component: ShowOperatorLayout,
		protected: true,
	},
	{
		path: '/operator/overview/module/:module_id/controller/:controller_id',
		optional_subdomains: ['operator'],
		name: 'operator_overview_module_controller',
		component: ShowOperatorLayout,
		protected: true,
	},

	//COBRA Agent
	{
		path: '/agent/download',
		name: 'cobra_agent_download',
		component: COBRAAgentDownload,
		protected: false,
		title: 'COBRA Agent Download',
	},
	{
		path: '/agent/download/:version',
		name: 'cobra_agent_download_version',
		component: COBRAAgentDownload,
		protected: false,
		title: 'COBRA Agent Download',
	},
	{
		path: '/download',
		subdomains: ['operator'],
		name: 'operator_cobra_agent_download',
		component: COBRAAgentDownload,
		protected: false,
		title: 'COBRA Agent Download',
	},
	{
		path: '/download/:version',
		subdomains: ['operator'],
		name: 'operator_cobra_agent_download_version',
		component: COBRAAgentDownload,
		protected: false,
		title: 'COBRA Agent Download',
	},

	// Admin
	// {
	//     path: '/users',
	//     name: 'users',
	//     component: Users,
	//     title: 'Users',
	//     protected: true,
	//     resource: RBACHelper.RESOURCES.PROFILE,
	//     resource_action: RBACHelper.ACTIONS.READ_ANY,
	// },
	// {
	//     path: '/users/:uuid',
	//     name: 'user',
	//     component: User,
	//     title: 'User',
	//     protected: true,
	//     resource: RBACHelper.RESOURCES.PROFILE,
	//     resource_action: RBACHelper.ACTIONS.READ_ANY,
	// },

	//User Manage
	// {
	//     path: '/widgets/max_ignitors',
	//     name: 'max_ignitors_widget',
	//     component: WidgetMaxIgnitorsCalculator,
	//     title: 'Test',
	//     meta: {
	//         prefers_fullscreen: true,
	//     }
	// },

	// {
	//     path: '/logout',
	//     name: 'logout',
	//     component: Logout,
	//     title: 'Logout'
	// },
	// {
	//     path: '/logout/sso/:source?',
	//     name: 'logout_sso',
	//     component: Logout,
	//     title: 'SSO Logout'
	// },

	{
		path: '/403',
		name: '403',
		component: Forbidden403,
		is_utility_route: true,
	},

	{
		path: '/404',
		name: '404',
		component: NotFound404,
		is_utility_route: true,
	},
	{
		path: '/:pathMatch(.*)*',
		name: '404',
		component: NotFound404,
		is_utility_route: true,
	},
	{
		path: '/:pathMatch(.*)',
		name: '404',
		component: NotFound404,
		is_utility_route: true,
	},
];

let redirects = [
	{
		path: '/operator/overview',
		redirect_path: '/operator/overview/all',
	},
	{
		path: '/operator/controls',
		redirect_path: '/operator/controls/all_controls',
	},
];

let supported_subdomains = ['operator'];

let subdomain = getSubdomain();
routes = routes.filter((route) => {
	if (route.is_utility_route == true) {
		return true;
	}

	if (subdomain == undefined) {
		if (route.subdomains != undefined && route.subdomains.length > 0) {
			return false;
		}
	} else if (supported_subdomains.includes(subdomain) == true) {
		//Subdomain is set, only include routes that are supported for this subdomain.
		if ((route.subdomains == undefined || route.subdomains.length == 0) && (route.optional_subdomains == undefined || route.optional_subdomains.length == 0)) {
			return false;
		} else if (route.optional_subdomains != undefined && route.optional_subdomains.includes(subdomain) == false) {
			return false;
		} else if (route.subdomains != undefined && route.subdomains.includes(subdomain) == false) {
			return false;
		}
	}

	return true;
});

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach(async (to, from, next) => {
	// console.log('before each', to, from, next)

	const authStore = useAuthStore();

	let redirect_info = redirects.filter((route) => {
		return route.path == to.path;
	})[0];
	if (redirect_info != undefined) {
		//Redirect the route
		return next({
			path: redirect_info.redirect_path,
			query: to.query,
		});
	}

	let route_info =
		routes.filter((route) => {
			return pathToRegexp(route.path).exec(to.path) != null;
		})[0] || {};

	// console.log('protected route?', route_info, route_info.protected)

	if (to.path == '/') {
		//Handle redirecting logged in users to the main app
		if (authStore.access_token != undefined) {
			return next({ path: MAIN_ROUTE });
		}
	}

	// document.title = route_info.title != undefined ? `${route_info.title} | Elevate Studio` : 'Elevate Studio';
	let title = route_info.title != undefined ? `${route_info.title} | COBRA Show Creator` : 'COBRA Show Creator';
	if (route_info?.subdomains?.includes('operator') == true || route_info?.optional_subdomains?.includes('operator') == true) {
		title = route_info.title != undefined ? `${route_info.title} | COBRA Show Operator` : 'COBRA Show Operator';
	}
	document.title = title;

	//TODO: add back in router_history support if needed like in cobra_portal_ui repo via store
	// store.state.router_history.push(from);
	// console.log('previous route', store.getters.getPreviousRoute)
	// fetch latest version details and set in pinia store

	if (route_info.protected == true) {
		// console.log('protected route')
		if (authStore.access_token != undefined) {
			let response = await getUserDetails(); // get user details

			if (response?.error !== undefined) {
				console.log('unable to get details');
				next({
					path: '/login',
					query: { redirect: to.fullPath },
				});
			}

			// get subscription details
			response = await getSubscriptionDetails();
			if (response?.error !== undefined) {
				console.log('unable to get SubscriptionDetails');
			}

			//Validate they can access this resource
			if (route_info.resource == undefined) {
				return next();
			}

			await RBACHelper.validateRoleBasedAccess(route_info.resource_action ?? RBACHelper.ACTIONS.READ_ANY, route_info.resource)
				.then(async () => {
					next(); //Continue;
				})
				.catch((failed_data) => {
					console.log('Failed to validate access to resource', failed_data);
					next({ path: '/403' });
				});
			return;
		} else {
			next({
				path: '/login',
				query: { redirect: to.fullPath },
			});
		}
	}

	next();
});

export default router;

function getSubdomain() {
	const host = window.location.hostname;
	const host_components = host.split('.');

	if (host_components.length >= 3) {
		return host_components[0];
	}

	return undefined;
}
